module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(7)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Xfinity logo
 * ```jsx
 * <IconXfinity />
 * ```
 */
var IconXfinity = function IconXfinity(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react["default"].createElement("span", _extends({
    className: "svg-icon ".concat(className)
  }, props), _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 23.3"
  }, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M7.71 11.76L12 6h-1.77a2 2 0 0 0-1.76.86L6.19 9.88 4 6.81A2 2 0 0 0 2.21 6H.4l4.28 5.81L0 18.09h1.71a2 2 0 0 0 1.76-.86l2.71-3.59 6.35 8.78a2 2 0 0 0 1.76.86h1.86zm34.68 6.33h2.45V6h-2.45zm-19.45 0h2.46V6h-2.46zm37.18 4.28L69 6h-1.33a1.81 1.81 0 0 0-1.76.86l-3.5 6.5-3-6.5A1.75 1.75 0 0 0 57.62 6h-1.28L61 15.85l-4.07 7.43h1.33a2 2 0 0 0 1.86-.91zM28.32 6v12.09h2.45V9.76A3.86 3.86 0 0 1 34 8c1.81 0 3 1.14 3 3.43v5.47a1.11 1.11 0 0 0 1.14 1.17h1.31V11c0-3.14-2-5.33-4.9-5.33a5.47 5.47 0 0 0-3.81 1.45V6zm21.06 7.83a4.21 4.21 0 0 0 4.52 4.52 6.23 6.23 0 0 0 1.79-.24l-.5-2.14a5 5 0 0 1-1.12.12 2.08 2.08 0 0 1-2.24-2.31V8.14h3.43L54.27 6h-2.43V1.07l-2.45 1.07V6h-2.6v2.14h2.59zm-34-5.64v9.95h2.45v-10H21V6h-3.15V5c0-2.07 1.24-2.76 2.45-2.76a2.93 2.93 0 0 1 .83.12l.5-2.17A4.29 4.29 0 0 0 20.11 0c-3 0-4.71 2.26-4.71 5v1h-1.29l-1.54 2.14z"
  })));
};

IconXfinity.propTypes = {
  /** CSS class for icon */
  className: _propTypes["default"].string
};
var _default = IconXfinity;
exports["default"] = _default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _browserInterface = _interopRequireDefault(__webpack_require__(4));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Renders loading indicator if isHarness = false, if true, sends messages to native instead
 * ```jsx
 * <Loading />
 * ```
 * For more information about Harness messaging, see the [Harness wiki](https://github.comcast.com/Harness/harness-web/wiki/Communication#loading)
 */
var Loading =
/*#__PURE__*/
function (_Component) {
  _inherits(Loading, _Component);

  function Loading() {
    _classCallCheck(this, Loading);

    return _possibleConstructorReturn(this, _getPrototypeOf(Loading).apply(this, arguments));
  }

  _createClass(Loading, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _browserInterface["default"].sendMessageToNative({
        type: 'LOADING'
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _browserInterface["default"].sendMessageToNative({
        type: 'LOADED'
      });
    }
  }, {
    key: "render",
    value: function render() {
      return !this.props.isHarness && _react["default"].createElement("div", {
        className: "loading"
      }, _react["default"].createElement("div", {
        className: "loading__content"
      }, _react["default"].createElement("div", {
        className: "loading__dots"
      }, _react["default"].createElement("div", {
        className: "loading__dot"
      }), _react["default"].createElement("div", {
        className: "loading__dot"
      }), _react["default"].createElement("div", {
        className: "loading__dot"
      }))));
    }
  }]);

  return Loading;
}(_react.Component);

;
Loading.propTypes = {
  /** Boolean that triggers harness functionality, defaults to false */
  isHarness: _propTypes["default"].bool
};
Loading.defaultProps = {
  isHarness: false
};
var _default = Loading;
exports["default"] = _default;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},listeners=[];window.BrowserInterface=window.BrowserInterface||{},BrowserInterface.sendMessageToNative=function(a){var b=a.type,c=void 0===b?"":b,d=a.payload,e=JSON.stringify({type:c,payload:d});return window.NativeInterface&&window.NativeInterface.message?window.NativeInterface.message(e):window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.observe&&window.webkit.messageHandlers.observe.postMessage&&window.webkit.messageHandlers.observe.postMessage(e),e},BrowserInterface.sendMessageToBrowser=function(a){var b=a.type,c=b===void 0?"":b,d=a.payload,e=!0,f=!1,g=void 0;try{for(var h,i,j=listeners[Symbol.iterator]();!(e=(h=j.next()).done);e=!0)i=h.value,i({type:c,payload:d})}catch(a){f=!0,g=a}finally{try{!e&&j.return&&j.return()}finally{if(f)throw g}}},BrowserInterface.addListener=function(a){if("function"==typeof a)listeners.push(a);else throw TypeError("Expected "+("undefined"==typeof a?"undefined":_typeof(a))+" to be a function")};/* harmony default export */ __webpack_exports__["default"] = (BrowserInterface);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PageHeader", {
  enumerable: true,
  get: function get() {
    return _PageHeader["default"];
  }
});
Object.defineProperty(exports, "PageFooter", {
  enumerable: true,
  get: function get() {
    return _PageFooter["default"];
  }
});
Object.defineProperty(exports, "Loading", {
  enumerable: true,
  get: function get() {
    return _Loading["default"];
  }
});
Object.defineProperty(exports, "LoadingCard", {
  enumerable: true,
  get: function get() {
    return _LoadingCard["default"];
  }
});
Object.defineProperty(exports, "PageSection", {
  enumerable: true,
  get: function get() {
    return _PageSection["default"];
  }
});
Object.defineProperty(exports, "FormBoolean", {
  enumerable: true,
  get: function get() {
    return _FormBoolean["default"];
  }
});
Object.defineProperty(exports, "FormControl", {
  enumerable: true,
  get: function get() {
    return _FormControl["default"];
  }
});
Object.defineProperty(exports, "HarnessExitButton", {
  enumerable: true,
  get: function get() {
    return _HarnessExitButton["default"];
  }
});
Object.defineProperty(exports, "IconCheckGreen", {
  enumerable: true,
  get: function get() {
    return _CheckGreen["default"];
  }
});
Object.defineProperty(exports, "IconCircleExclamation", {
  enumerable: true,
  get: function get() {
    return _CircleExclamation["default"];
  }
});
Object.defineProperty(exports, "IconCloseX", {
  enumerable: true,
  get: function get() {
    return _CloseX["default"];
  }
});
Object.defineProperty(exports, "IconXfinity", {
  enumerable: true,
  get: function get() {
    return _Xfinity["default"];
  }
});

var _PageHeader = _interopRequireDefault(__webpack_require__(6));

var _PageFooter = _interopRequireDefault(__webpack_require__(9));

var _Loading = _interopRequireDefault(__webpack_require__(3));

var _LoadingCard = _interopRequireDefault(__webpack_require__(10));

var _PageSection = _interopRequireDefault(__webpack_require__(11));

var _FormBoolean = _interopRequireDefault(__webpack_require__(12));

var _FormControl = _interopRequireDefault(__webpack_require__(13));

var _HarnessExitButton = _interopRequireDefault(__webpack_require__(14));

var _CheckGreen = _interopRequireDefault(__webpack_require__(15));

var _CircleExclamation = _interopRequireDefault(__webpack_require__(16));

var _CloseX = _interopRequireDefault(__webpack_require__(17));

var _Xfinity = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Xfinity = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Displays the default XFINITY logo wrapped in a link back "/".
 * @param props.logoLink
 *  The logo is wrapped in a link to pointing /. Use this value to override it.
 * @returns {*}
 * @constructor
 */
var Logo = function Logo(props) {
  var logoLink = props.logoLink;
  return _react["default"].createElement("div", {
    className: "page-header__logo-wrap"
  }, _react["default"].createElement("a", {
    href: logoLink,
    className: "page-header__logo",
    rel: "home"
  }, _react["default"].createElement(_Xfinity["default"], {
    className: "page-header__logo-svg"
  }), _react["default"].createElement("span", {
    className: "visuallyhidden"
  }, "XFINITY")));
};
/**
 * Display a formatted page header.
 * ```jsx
 * <PageHeader />
 * ```
 * @param props
 * @returns {*}
 * @constructor
 */


var PageHeader = function PageHeader(props) {
  var children = props.children,
      showLogo = props.showLogo,
      logoLink = props.logoLink,
      headerText = props.headerText,
      back = props.back,
      cancel = props.cancel;
  return _react["default"].createElement("header", {
    id: "page-header",
    className: "page-header",
    role: "banner"
  }, showLogo && _react["default"].createElement(Logo, {
    logoLink: logoLink
  }), headerText && _react["default"].createElement("div", {
    className: "page-header__title"
  }, headerText), _react["default"].createElement("div", {
    className: "page-header__cancel"
  }, cancel), _react["default"].createElement("div", {
    className: "page-header__back"
  }, back), children);
};

PageHeader.propTypes = {
  /** Additional naviigation content */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]),

  /** Whether to display Xfinity logo */
  showLogo: _propTypes["default"].bool,

  /** href value for logo anchor */
  logoLink: _propTypes["default"].string,

  /** Header title */
  headerText: _propTypes["default"].string,

  /** Element for back (left-side) navigation */
  back: _propTypes["default"].node,

  /** Element for cancel (right-side) navigation */
  cancel: _propTypes["default"].node
};
PageHeader.defaultProps = {
  showLogo: true,
  logoLink: '/'
};
var _default = PageHeader;
exports["default"] = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(8);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** 
 * Footer element with Comcast copyright
 * ```jsx
 * <PageFooter />
 * ```
 * */
var PageFooter = function PageFooter(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$showCPPFooter = _ref.showCPPFooter,
      showCPPFooter = _ref$showCPPFooter === void 0 ? null : _ref$showCPPFooter,
      props = _objectWithoutProperties(_ref, ["className", "showCPPFooter"]);

  var copyright = "\xA9 ".concat(new Date().getFullYear(), " Comcast"); // Copyright

  var privacyNotice = _react["default"].createElement("a", {
    href: "https://www.xfinity.com/privacy/policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy");

  var doNotSellInfo = _react["default"].createElement("a", {
    href: "https://www.xfinity.com/privacy/manage-preference",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Do Not Sell My Personal Information"); // Subsection


  var footerDetails = [copyright];

  if (showCPPFooter) {
    footerDetails.push(privacyNotice);
    footerDetails.push(doNotSellInfo);
  }

  return _react["default"].createElement("div", _extends({
    className: "page-footer page-footer--thin ".concat(className)
  }, props), _react["default"].createElement("div", {
    className: "link-group"
  }, footerDetails.map(function (element) {
    return _react["default"].createElement("div", {
      className: "link-group__item"
    }, element);
  })));
};

var _default = PageFooter;
exports["default"] = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _Loading = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Renders loading card if isHarness = false, if true, sends messages to native instead
 * ```jsx
 * <LoadingCard />
 * ```
 * **NOTE**: `LoadingCard` will currently have unexpected behavior if it is not wrapped in a `PageSection` component. See the example below.
 * 
 * For more infofrmation about Harness functionality, see [Loading](#loading)
 */
var LoadingCard =
/*#__PURE__*/
function (_Component) {
  _inherits(LoadingCard, _Component);

  function LoadingCard() {
    _classCallCheck(this, LoadingCard);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingCard).apply(this, arguments));
  }

  _createClass(LoadingCard, [{
    key: "render",
    value: function render() {
      return !this.props.isHarness && _react["default"].createElement("div", {
        className: "card card--loading-dots"
      }, _react["default"].createElement("div", {
        className: "card__content"
      }, _react["default"].createElement(_Loading["default"], {
        isHarness: this.props.isHarness
      })));
    }
  }]);

  return LoadingCard;
}(_react.Component);

;
LoadingCard.propTypes = {
  /** Boolean that triggers harness functionality, defaults to false */
  isHarness: _propTypes["default"].bool
};
LoadingCard.defaultProps = {
  isHarness: false
};
var _default = LoadingCard;
exports["default"] = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Container component to wrap content
 * 
 * ```jsx
 * <PageSection>
 *  <p>Content here...</p>
 * </PageSection>
 * ```
 */
var PageSection = function PageSection(props) {
  var children = props.children,
      className = props.className;
  return _react["default"].createElement("div", {
    className: "page-section ".concat(className)
  }, _react["default"].createElement("div", {
    className: "page-section__wrapper"
  }, _react["default"].createElement("div", {
    className: "page-section__content"
  }, children)));
};

PageSection.propTypes = {
  /** Content */
  children: _propTypes["default"].any,

  /** CSS class for container */
  className: _propTypes["default"].string
};
var _default = PageSection;
exports["default"] = _default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Form control for checkboxes and radios
 * 
 * ```jsx
 * <FormBoolean label="Check box" inputId="checkbox">
 *  <input type="checkbox" id="checkbox"/>
 * </FormBoolean>
 * ```
 * **NOTE**: `inputId` value _must match_ `id` of child input
 *
 */
var FormBoolean = function FormBoolean(props) {
  var children = props.children,
      label = props.label,
      inputId = props.inputId,
      className = props.className,
      labelClass = props.labelClass;
  return _react["default"].createElement("div", {
    className: "form-control form-control--boolean ".concat(className)
  }, _react["default"].createElement("div", {
    className: "form-control__input"
  }, children, label && _react["default"].createElement("label", {
    className: "form-control__label",
    htmlFor: inputId
  }, _react["default"].createElement("span", {
    className: "form-control__label-text ".concat(labelClass)
  }, label))));
};

FormBoolean.propTypes = {
  /** Elements to be wrapped in control: must include input with type=radio|checkbox and id */
  children: _propTypes["default"].any.isRequired,

  /** Id of input child */
  inputId: _propTypes["default"].string.isRequired,

  /** CSS className for container */
  className: _propTypes["default"].string,

  /** Label text for input */
  label: _propTypes["default"].string,

  /** CSS className for label */
  labelClass: _propTypes["default"].string
};
var _default = FormBoolean;
exports["default"] = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Form control for an input
 * ```jsx
 * <FormControl label="Text input" inputId="textInput">
 *  <input id="textInput" type="text"/>
 * </FormControl>
 * ```
 * **NOTE**: `inputId` value _must match_ `id` of child input
 * 
 * For boolean input types (radio, checkbox), see [FormBoolean](#formboolean)
 */
var FormControl = function FormControl(props) {
  var children = props.children,
      label = props.label,
      inputId = props.inputId,
      className = props.className;
  return _react["default"].createElement("div", {
    className: "form-control ".concat(className)
  }, label && _react["default"].createElement("label", {
    className: "form-control__label",
    htmlFor: inputId
  }, label), _react["default"].createElement("div", {
    className: "form-control__input"
  }, children));
};

FormControl.propTypes = {
  /** Elements to be wrapped in control: must include an input with id */
  children: _propTypes["default"].any.isRequired,

  /** Id of input child */
  inputId: _propTypes["default"].string.isRequired,

  /** CSS className for container */
  className: _propTypes["default"].string,

  /** Label text for input */
  label: _propTypes["default"].string
};
var _default = FormControl;
exports["default"] = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _browserInterface = _interopRequireDefault(__webpack_require__(4));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Exit button for use within the Harness
 * ```jsx
 * <HarnessExitButton>Exit</HarnessExitButton>
 * ```
 */
var HarnessExitButton = function HarnessExitButton(props) {
  var intent = props.intent,
      children = props.children,
      className = props.className;

  var handleHarnessExit = function handleHarnessExit() {
    var message = {
      type: 'EXIT'
    };

    if (intent) {
      message.payload = {
        intent: intent
      };
    }

    return _browserInterface["default"].sendMessageToNative(message);
  };

  return _react["default"].createElement("button", {
    type: "button",
    className: "button ".concat(className),
    onClick: handleHarnessExit
  }, children);
};

HarnessExitButton.propTypes = {
  /** Button text */
  children: _propTypes["default"].node.isRequired,

  /** CSS className for button */
  className: _propTypes["default"].string,

  /** intent value for Harness app. See [the Harness wiki](https://github.comcast.com/Harness/harness-web/wiki/Communication#exit) for more info */
  intent: _propTypes["default"].string
};
HarnessExitButton.defaultProps = {
  intent: undefined,
  className: ''
};
var _default = HarnessExitButton;
exports["default"] = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A green checkmark icon
 * ```jsx
 * <IconCheckGreen />
 * ```
 */
var IconCheckGreen = function IconCheckGreen(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react["default"].createElement("span", _extends({
    className: "svg-icon ".concat(className)
  }, props), _react["default"].createElement("svg", {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M29.992 59.5C46.29 59.5 59.5 46.29 59.5 29.992 59.5 13.695 46.29.484 29.992.484 13.695.484.484 13.694.484 29.992S13.694 59.5 29.992 59.5z",
    fill: "#67D1A8",
    fillRule: "nonzero"
  }), _react["default"].createElement("path", {
    stroke: "#FFF",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.996 32.58l8.293 8.294 20.73-20.732"
  }))));
};

IconCheckGreen.propTypes = {
  /** CSS class for icon */
  className: _propTypes["default"].string
};
var _default = IconCheckGreen;
exports["default"] = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * An icon of an exclamation point within a circle
 * ```jsx
 * <IconCircleExclamation />
 * ```
 */
var IconCircleExclamation = function IconCircleExclamation(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react["default"].createElement("span", _extends({
    className: "svg-icon ".concat(className)
  }, props), _react["default"].createElement("svg", {
    width: "42",
    height: "42",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M21 0C9.402 0 0 9.402 0 21s9.402 21 21 21 21-9.402 21-21A21 21 0 0 0 21 0",
    fill: "#FFA700",
    fillRule: "nonzero"
  }), _react["default"].createElement("path", {
    d: "M22.643 31.357a1.643 1.643 0 1 1-3.286 0 1.643 1.643 0 0 1 3.286 0zM22.166 9a.82.82 0 0 1 .613.274.873.873 0 0 1 .219.649l-1.171 16.284A.845.845 0 0 1 21 27a.844.844 0 0 1-.826-.793L19.003 9.923a.869.869 0 0 1 .219-.649.818.818 0 0 1 .613-.274h2.33z",
    fill: "#FFF"
  }))));
};

IconCircleExclamation.propTypes = {
  /** CSS class for icon */
  className: _propTypes["default"].string
};
var _default = IconCircleExclamation;
exports["default"] = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * An "X" icon
 * ```jsx
 * <IconCloseX />
 * ```
 */
var IconCloseX = function IconCloseX(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react["default"].createElement("span", _extends({
    className: "svg-icon ".concat(className)
  }, props), _react["default"].createElement("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    strokeWidth: "2",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _react["default"].createElement("path", {
    d: "M21 21L1 1M1 21L21 1"
  }))));
};

IconCloseX.propTypes = {
  /** CSS class for icon */
  className: _propTypes["default"].string
};
var _default = IconCloseX;
exports["default"] = _default;

/***/ })
/******/ ]);